import dayjs from "dayjs";
import { baseAxios } from "../../utils/config";

/**
 * Stylist time off API (JD-465). Times cross the API as salon wall-clock
 * strings; a block covers [start, end).
 */
export const TIME_OFF_WALL_CLOCK = "YYYY-MM-DD HH:mm:ss";

const toWallClock = (value) =>
  typeof value === "string" ? value : dayjs(value).format(TIME_OFF_WALL_CLOCK);

/** Time-off blocks overlapping [from, to) (API defaults: today → +90 days). */
export async function listTimeOff({ userId, from, to } = {}) {
  const params = {};
  if (userId != null && userId !== "") params.user_id = userId;
  if (from) params.from = toWallClock(from);
  if (to) params.to = toWallClock(to);
  const res = await baseAxios.get("/time-off", { params });
  return res.data?.timeOff ?? [];
}

/**
 * Record (no id) or update (id) a block. Resolves `{ timeOff, conflicts }`.
 * Rejects with the API error; a 409 TIME_OFF_CONFLICTS is handled by the
 * dialog, which resends with `acknowledge_conflicts: true`.
 */
export async function saveTimeOff(payload, id) {
  const body = {
    ...payload,
    start: toWallClock(payload.start),
    end: toWallClock(payload.end),
  };
  const res = id
    ? await baseAxios.put(`/time-off/${id}`, body)
    : await baseAxios.post("/time-off", body);
  return res.data;
}

export async function deleteTimeOff(id) {
  const res = await baseAxios.delete(`/time-off/${id}`);
  return res.data;
}

/** The API refused the save because appointments sit in the window. */
export function isTimeOffConflictError(err) {
  return (
    err?.response?.status === 409 &&
    err.response.data?.code === "TIME_OFF_CONFLICTS"
  );
}

/** The API refused a booking because the stylist is on time off. */
export function isStylistTimeOffError(err) {
  return (
    err?.response?.status === 409 &&
    err.response.data?.code === "STYLIST_TIME_OFF"
  );
}
